<template>
    <div v-on-click-outside="() => showDatePicker = false" class="datepicker-input__wrap">
        <date-time-input
            :modelValue="formattedDate"
            :placeholder="props.placeholder"
            :format="props.format"
            @focus="showDatePicker = true"
            :library="props.library"
            :error="props.error"
        />
        <div v-if="showDatePicker" class="datepicker-input__datepicker">
            <date-time-picker :modelValue="date" mode="date" @update:modelValue="emitModelValue" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import DateTimeInput from './DateTimeInput.vue';
import DateTimePicker from './DateTimePicker.vue';
import { vOnClickOutside } from '@vueuse/components';
import dayjs from '~/utils/dayjs';
import { ref, watch, computed } from 'vue';

interface Props {
    modelValue?: string;
    placeholder?: string;
    format?: string;
    library?: boolean;
    error?: string;
}

const props = withDefaults(defineProps<Props>(), {
    format: 'MM/DD/YYYY',
});

const emit = defineEmits<{
    'update:modelValue': [value: string];
}>();

const showDatePicker = ref(false);
const date = ref<Date | null>(null);

watch(() => props.modelValue, (newValue) => {
    if (newValue === undefined || newValue === '') {
        date.value = null;
        return;
    }
    const parsed = dayjs.utc(newValue, 'YYYY-MM-DD');
    date.value = parsed.isValid() ? parsed.toDate() : null;
}, { immediate: true });

const formattedDate = computed(() =>
    date.value ? dayjs.utc(date.value).format(props.format) : undefined,
);

const emitModelValue = (event: Date | string) => {
    emit('update:modelValue', dayjs.utc(event).format('YYYY-MM-DD'));
};
</script>

<style>
.datepicker-input__datepicker {
  position: absolute;
  z-index: 11;
  width: 275px;
}
.datepicker-input__wrap {
  position: relative;
}
</style>
